// extracted by mini-css-extract-plugin
export default {"container":"start_container__fn6vR","count__div":"start_count__div__THFi2","count__number":"start_count__number__nCWsl","animation":"start_animation__IM8+t"};